module.exports = function getResource(label, vars = []) {
    const resources = {
        shipToFedex: 'Ship to FedEx Pickup Location',
        selectLocationNearYou: 'Select a location near you',
        orShipToFedexLocation: 'Or ship to a FedEx Pickup Location near you',
        accessPointInfoTitle: 'Shipping to a FedEx Pickup Location',
        changeAlternateLocation: 'Change alternate pickup location'
    };

    return resources[label];
};
